export default __webpack_public_path__ + "static/media/fail_section.fa57a2c5.svg";